import { Link } from 'react-router-dom';
import Banknote from '../../assets/icons/Profile/banknote.svg?react';
import Request from '../../assets/icons/Profile/Load-Request.svg?react';
import Withdrawal from '../../assets/icons/Profile/Withdrawal-Request.svg?react';
import Game from '../../assets/icons/Profile/Game.svg?react';
import Results from '../../assets/icons/Profile/Game-Results.svg?react';
import Users from '../../assets/icons/Profile/Users.svg?react';
import Transactions from '../../assets/icons/Profile/Transactions.svg?react';
import Commissions from '../../assets/icons/Profile/Commissions.svg?react';
import Reports from '../../assets/icons/Profile/Reports.svg?react';
import Logs from '../../assets/icons/Profile/Logs.svg?react';
import Userfile from '../../assets/icons/Profile/file-chart-pie.svg?react';
import Profile from '../../assets/icons/Profile/Profile.svg?react';
import SignOut from '../../assets/icons/Profile/Sign-Out.svg?react';
import LoadingStationPopup from '../../components/Popup/LoadingStationPopup';
import { useContext, useState, useEffect } from 'react';
import { NavigationContext } from '../../context/NavigationContext';
import {
  MonitorCog,
  Printer,
  Settings as SettingsIcon,
  ListFilter,
  TrendingUp,
  AlertCircle,
  RefreshCw,
  Package,
  CreditCard,
  HeadphonesIcon,
} from 'lucide-react';
import { Badge } from 'flowbite-react';
import { useBottomNav } from '../../context/BottomNavContext';

import { useAuth } from '../../context/AuthContext';
import { loadRequestApi } from '../../api/loadrequest';
import { withdrawalsApi } from '../../api/withdrawals';
import Swal from 'sweetalert2';

const actions = [
  {
    icon: <Banknote />,
    label: 'Loading Station',
    to: '/loading-station',
    role: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    icon: <Request />,
    label: 'Load Request',
    to: '/load-request',
  },
  {
    icon: <Withdrawal />,
    label: 'Withdrawal Request',
    to: '/withdrawal-request',
  },
  {
    icon: <Game />,
    label: 'Games Package',
    to: '/games-package',
    role: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    icon: <MonitorCog color='#0E64D1' />,
    label: 'Games Settings',
    to: '/game-settings',
    role: [1],
  },
  // {
  //   icon: <Package color="#0E64D1"/>,
  //   label: "Default Games",
  //   to: "/default-game-packages",
  //   role: [1]
  // },
  {
    icon: <ListFilter color='#0E64D1' />,
    label: 'Bet Limits',
    to: '/bet-limits',
    role: [1],
  },
  {
    icon: <AlertCircle color='#0E64D1' />,
    label: 'Overall Limits',
    to: '/overall-bet-limits',
    role: [1],
  },
  {
    icon: <TrendingUp color='#0E64D1' />,
    label: 'Hot Numbers',
    to: '/hot-numbers',
    role: [1],
  },
  {
    icon: <Results />,
    label: 'Game Results',
    to: '/game-results',
  },
  {
    icon: <Users />,
    label: 'Users',
    to: '/users-imp',
    role: [1, 2, 3, 4, 5, 6, 7, 8],
  },
  {
    icon: <Transactions />,
    label: 'Transactions',
    to: '/transactions',
  },
  {
    icon: <Commissions />,
    label: 'Commissions',
    to: '/commissions',
  },
  {
    icon: <Reports />,
    label: 'Reports',
    to: '/reports',
  },
  { icon: <Logs />, label: 'Logs', to: '/logs' },
  {
    icon: <Userfile />,
    label: 'User Reports',
    to: '/user-reports',
  },
  {
    icon: <Profile />,
    label: 'Profile',
    to: '/profile',
  },
  {
    icon: <SettingsIcon color='#0E64D1' />,
    label: 'Settings',
    to: '/settings',
    role: [1,2,3],
  },
  {
    icon: <HeadphonesIcon color='#0E64D1' />,
    label: 'Support',
    to: '/support',
  },
  {
    icon: <Printer color='#0E64D1' />,
    label: 'Printer Settings',
  },
  {
    icon: <RefreshCw color='#0E64D1' />,
    label: 'Refresh App',
  },
  // {
  //   icon: <Package color="#0E64D1" />,
  //   label: "Homepage Games",
  //   to: "/home-settings",
  //   role: [1]
  // },

  // {
  //   icon: <CreditCard color='#0E64D1' />,
  //   label: 'Payment Transactions',
  //   to: '/payment-transactions',
  //   role: [1, 2, 3, 4, 5, 6, 7, 8, 9],
  // },
  {
    icon: <SignOut />,
    label: 'Sign Out',
    to: '/',
  },
];

// export default function ActionGrid() {
//   const [loadingStation, setLoadingStation] = useState(false);

//   return (
//     <>
//       <div
//         className="grid grid-cols-3 gap-2.5 p-4 overflow-y-auto hide-scrollbar "
//         style={{ height: "calc(100vh - 500px)" }}
//       >
//         {actions.map((action) => (
//           <Link
//             key={action.label}
//             to={action.to}
//             className="flex flex-col items-center justify-center p-4 bg-white rounded-lg border border-[#E1E7EF] shadow-sm"
//           >
//             <div className=" mb-2">{action.icon}</div>
//             <span className="text-[#12131A] text-sm text-center font-semibold">
//               {action.label}
//             </span>
//           </Link>
//         ))}
//       </div>

//       <LoadingStationPopup
//         isOpen={loadingStation}
//         onClose={() => setLoadingStation(false)}
//       ></LoadingStationPopup>
//     </>
//   );
// }

export default function ActionGrid({ userInfo, wallet }) {
  const role = userInfo?.roleId;
  const [loadingStation, setLoadingStation] = useState(false);
  const { setIsBackNavigation } = useContext(NavigationContext);
  const [loadRequestCount, setLoadRequestCount] = useState(0);
  const [withdrawalCount, setWithdrawalCount] = useState(0);
  const { tokens, logout } = useAuth();
  const [hasPrinter, setHasPrinter] = useState(false);
  const { isIOS } = useBottomNav();

  const handleSignOut = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will be logged out of your account',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, sign out',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  useEffect(() => {
    if (window.ReactNativeWebView) {
      setHasPrinter(true);
    }
    const fetchCounts = async () => {
      try {
        const loadRequestResponse = await loadRequestApi.getLoadRequestCount(
          tokens.access.token
        );
        const withdrawalResponse = await withdrawalsApi.getWithdrawalsCount(
          tokens.access.token
        );

        setLoadRequestCount(loadRequestResponse.data.count);
        setWithdrawalCount(withdrawalResponse.data.count);
      } catch (error) {
        console.error('Error fetching counts:', error);
      }
    };

    fetchCounts();
  }, [tokens]);

  return (
    <>
      <div className='grid grid-cols-3 gap-2 px-4 py-3 overflow-y-auto mb-4'>
        {actions.map((action) => {
          if (action.label === 'Loading Station') {
            if (action.role?.includes(role)) {
              return (
                <div
                  key={action.label}
                  className='flex flex-col items-center justify-center p-3 bg-white rounded-lg border border-[#E1E7EF] shadow-sm cursor-pointer h-[80px]'
                  onClick={() => setLoadingStation(true)}
                >
                  <div className='mb-2'>{action.icon}</div>
                  <span className='text-[#12131A] text-xs text-center font-semibold'>
                    {action.label}
                  </span>
                </div>
              );
            }
            return null;
          }

          if (action.label === 'Printer Settings') {
            if (!hasPrinter) {
              return null;
            }
            return (
              <button
                onClick={() => {
                  window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                      action: 'open-printer-setting',
                    })
                  );
                }}
                className='flex flex-col items-center justify-center p-3 bg-white rounded-lg border border-[#E1E7EF] shadow-sm cursor-pointer h-[80px]'
              >
                <div className='mb-2'>{action.icon}</div>
                <span className='text-[#12131A] text-xs text-center font-semibold'>
                  {action.label}
                </span>
              </button>
            );
          }

          if (action.label === 'Refresh App') {
            if (!hasPrinter) {
              return null;
            }
            return (
              <div
                key={action.label}
                onClick={() => window.location.reload(true)}
                className='flex flex-col items-center justify-center p-3 bg-white rounded-lg border border-[#E1E7EF] shadow-sm cursor-pointer h-[80px]'
              >
                <div className='mb-2'>{action.icon}</div>
                <span className='text-[#12131A] text-xs text-center font-semibold'>
                  {action.label}
                </span>
              </div>
            );
          }

          if (action.label === 'Sign Out') {
            return (
              <div
                key={action.label}
                onClick={handleSignOut}
                className='flex flex-col items-center justify-center p-3 bg-white rounded-lg border border-[#E1E7EF] shadow-sm cursor-pointer h-[80px]'
              >
                <div className='mb-2'>{action.icon}</div>
                <span className='text-[#12131A] text-xs text-center font-semibold'>
                  {action.label}
                </span>
              </div>
            );
          }

          if (!action.role || action.role.includes(role)) {
            return (
              <Link
                key={action.label}
                to={action.to}
                onClick={() => setIsBackNavigation(false)}
                className='flex flex-col items-center justify-center p-3 bg-white rounded-lg border border-[#E1E7EF] shadow-sm relative h-[80px]'
              >
                {action.label === 'Load Request' && loadRequestCount > 0 && (
                  <Badge
                    style={{ backgroundColor: '#fde8e8', color: '#9b1c1c' }}
                    size='xs'
                    className='absolute top-1 right-1 rounded-full'
                  >
                    {loadRequestCount}
                  </Badge>
                )}
                {action.label === 'Withdrawal Request' &&
                  withdrawalCount > 0 && (
                    <Badge
                      style={{ backgroundColor: '#fde8e8', color: '#9b1c1c' }}
                      size='xs'
                      className='absolute top-1 right-1 rounded-full'
                    >
                      {withdrawalCount}
                    </Badge>
                  )}
                {action.label === 'Support' && (
                  <Badge
                    style={{ backgroundColor: '#10b981', color: '#ffffff' }}
                    size='xs'
                    className='absolute top-1 right-1 rounded-full'
                  >
                    NEW
                  </Badge>
                )}
                <div className='mb-2'>{action.icon}</div>
                <span className='text-[#12131A] text-xs text-center font-semibold'>
                  {action.label}
                </span>
              </Link>
            );
          }
          return null;
        })}
      </div>

      <LoadingStationPopup
        isOpen={loadingStation}
        onClose={() => setLoadingStation(false)}
        wallet={wallet}
      />
    </>
  );
}
